import styled from 'styled-components';
import { Menu, Badge } from '@material-ui/core';
import { SIZES } from 'common/constants/sizes';
import { MenuButtonItem } from 'components/MenuButton';
import { BadgeWrapper } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import { withStyles } from '@material-ui/core/styles';
import { LBButton } from '@linearb/buzz';

const DisabledMenuWrapper = styled.div`
  background: white;
  opacity: 0.3;
  pointer-events: none;
`;

const StyledMenu = styled(Menu)`
  ul {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-right: unset !important;
    width: unset !important;
  }
  max-height: 50rem !important;
  .MuiPopover-paper {
    overflow-y: hidden !important;
    ${({ width }) => `min-width: ${width ? width : '20rem !important'};`}
  }
`;

const StyledMenuHeaderItem = styled.li`
  line-height: 2rem !important;
  font-size: ${SIZES.small};
  padding: 1rem 1rem 0.5rem 1rem;
  color: ${getColor('shuttleGray')} !important;
  text-transform: uppercase;
  &:not(:first-child) {
    border-top: 1px solid ${getColor('catskillWhite')};
  }
`;

const StyledMenuFreeItem = styled.li`
  line-height: 3rem !important;
  padding: 0.5rem 1rem;
`;

const MenuBadge = withStyles(() => ({
  badge: {
    padding: '0 0.4rem',
    backgroundColor: getColor('dodgerBlue'),
    fontSize: '1rem',
    height: '1.4rem',
    minWidth: '1.4rem',
    lineHeight: '1.4rem',
    top: '6%',
    right: '6%'
  }
}))(Badge);

const renderDefaultMenuItems = ({ menuItems, handleMenuClose }) => {
  if (!menuItems.length) {
    return [];
  }
  return menuItems.map(
    ({
      title,
      children,
      type,
      icon,
      onClick,
      inactive,
      condition = true,
      badge
    }) => {
      if (!condition) return false;

      return type === 'header' ? (
        <StyledMenuHeaderItem key={title}>{title}</StyledMenuHeaderItem>
      ) : children ? (
        <StyledMenuFreeItem onClick={() => handleMenuClose()} key={title}>
          {children}
        </StyledMenuFreeItem>
      ) : (
        <li key={title}>
          <MenuButtonItem
            text={title}
            disabled={inactive}
            icon={icon && <Icon name={icon} color='nepal' />}
            tag={badge && <BadgeWrapper right='1.4rem'>{badge}</BadgeWrapper>}
            onClick={() => {
              onClick();
              handleMenuClose();
            }}
          />
        </li>
      );
    }
  );
};

const TopBarMenu = ({
  id,
  icon = '',
  menuItems,
  renderMenuItems = renderDefaultMenuItems,
  badgeContent = 0,
  disableClick = false,
  disableMenu = false,
  width,
  anchorEl,
  setAnchorEl
}) => {
  const handleMenuOpen = event => {
    setAnchorEl({ [id]: event.currentTarget });
  };

  const handleMenuClose = () => {
    setAnchorEl({});
  };

  return (
    <>
      <LBButton
        id={id}
        aria-controls={id}
        aria-haspopup='true'
        size='icon'
        variant='ghost'
        onClick={disableClick ? () => {} : e => handleMenuOpen(e)}
      >
        {badgeContent > 0 ? (
          <MenuBadge
            id={`${id}-badge`}
            badgeContent={badgeContent}
            color='primary'
            overlap='circular'
          >
            <Icon name={icon} />
          </MenuBadge>
        ) : (
          <Icon name={icon} />
        )}
      </LBButton>

      <StyledMenu
        id={id}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleMenuClose()}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        width={width}
      >
        {disableMenu ? (
          <DisabledMenuWrapper>
            {renderMenuItems({
              menuItems,
              handleMenuClose
            })}
          </DisabledMenuWrapper>
        ) : (
          renderMenuItems({
            menuItems,
            handleMenuClose
          })
        )}
      </StyledMenu>
    </>
  );
};

export default TopBarMenu;
